<template>
  <div class="flex">
    <div class="flex items-center" v-if="!editCashlessPay">
      <DeleteConfirmation v-model="showDeleteConfirmation" :isSiteConfig="isSiteConfig" />

      <Button
        id="delete-cashless-pay"
        severity="danger"
        outlined
        :label="t('sites.singleSite.financialConfig.cashlessPay.actions.delete')"
        class="mr-4"
        @click.stop="openDeleteConfirmation"
        v-if="hasCashlessPay"
      >
        <template #icon>
          <i class="material-symbols-rounded text-[1.5rem] mr-2">delete</i>
        </template>
      </Button>

      <IconButton id="edit-cashless-pay" class="c-icon-button" @click.stop="editCashlessPayMethod">
        <template #icon>
          <i class="material-symbols-rounded text-[1.5rem]">edit</i>
        </template>
      </IconButton>
    </div>

    <div class="flex" v-else>
      <Button
        id="cancel-edit-cashless-pay"
        outlined
        severity="secondary"
        class="mr-4"
        :label="t('sites.singleSite.financialConfig.cashlessPay.actions.cancel')"
        @click.stop="cancelCashlessPayMethod"
      />

      <Button
        id="save-edit-cashless-pay"
        :label="t('sites.singleSite.financialConfig.cashlessPay.actions.save')"
        @click.stop="saveEditCashlessPay"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFormStore } from '@centric-os/stores/form/use-form-store';
import { useCashlessPay } from '../composables';
import { useEventBus } from '@vueuse/core';
import DeleteConfirmation from '../delete-confirmation/DeleteConfirmation.vue';
import { ref } from 'vue';
import { useFinancialConfigStore } from '../../../../../routes';
import { FinancialFormIDs } from '../../enums';

const props = defineProps({
  isSiteConfig: {
    type: Boolean,
    required: true,
  },
});

// Ref for show delete confirmation
const showDeleteConfirmation = ref<boolean>(false);

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editCashlessPay } = storeToRefs(fConfigStore);

// Set cashless pay composable
const { hasCashlessPay } = useCashlessPay();

// Set form store
const formStore = useFormStore();
const form = formStore.getForm(FinancialFormIDs.CASHLESS_PAY_FORM);

// Set edit cashless pay method
const editCashlessPayMethod = (): void => {
  editCashlessPay.value = true;
};

// Cancel edit cashless pay method
const cancelCashlessPayMethod = (): void => {
  editCashlessPay.value = false;
  form.value?.resetForm();
};

// Set event bus for saving cashless pay
const { emit: saveEdit } = useEventBus<void>(
  `save-cashless-pay-${props.isSiteConfig ? 'site' : 'station'}`,
);

// Save edit cashless pay method
const saveEditCashlessPay = (): void => {
  saveEdit();
};

// Method to show delete confirmation
const openDeleteConfirmation = (): void => {
  showDeleteConfirmation.value = true;
};
</script>
